import React from 'react';
import { ChevronRight } from 'lucide-react';
import styles from './PageHeader.module.css';

const PageHeader = ({ title, breadcrumb = [], actionButton }) => {
  return (
    <div className={styles.pageHeader}>
      <div className={styles.headerContent}>
        {breadcrumb.length > 0 && (
          <nav className={styles.breadcrumb}>
            {breadcrumb.map((item, index) => (
              <React.Fragment key={index}>
                <span className={index === breadcrumb.length - 1 ? styles.active : ''}>
                  {item}
                </span>
                {index < breadcrumb.length - 1 && <ChevronRight size={12} className={styles.separator} />}
              </React.Fragment>
            ))}
          </nav>
        )}
        <h1 className={styles.title}>{title}</h1>
      </div>
      
      {actionButton && (
        <div className={styles.actionArea}>
          {actionButton}
        </div>
      )}
    </div>
  );
};

export default PageHeader;
